import axios from "axios";
import CryptoJS from "crypto-js";
import { isLocalhost } from "../../checkLocalhost";

// === CONFIGURATION ===
const SECRET = "=!rajeshkhetrapl-kashish-shanta="; // same key as PHP


const BASE_URL = isLocalhost
  ? import.meta.env.VITE_DSERVER_BASEURL + import.meta.env.VITE_API
  : import.meta.env.VITE_SH_DSERVER_BASEURL + import.meta.env.VITE_SH_API;

// === CREATE AXIOS INSTANCE ===
const encryptedapiRequest = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// === REQUEST INTERCEPTOR (Optional encryption) ===
encryptedapiRequest.interceptors.request.use((config) => {
  // If you want to encrypt outgoing requests, uncomment below:
  /*
  if (config.data) {
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(config.data),
      CryptoJS.enc.Utf8.parse(SECRET),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();

    config.data = {
      iv: CryptoJS.enc.Base64.stringify(iv),
      data: encrypted,
    };
  }
  */
  return config;
}, (error) => Promise.reject(error));

// === RESPONSE INTERCEPTOR (Auto-decrypt) ===
encryptedapiRequest.interceptors.response.use(
  (res) => {
    // Check if response is encrypted (PHP returns { iv, data })
    if (res.data?.iv && res.data?.data) {

      try {
        const iv = CryptoJS.enc.Base64.parse(res.data.iv);
        const key = CryptoJS.enc.Utf8.parse(SECRET);

        const decrypted = CryptoJS.AES.decrypt(res.data.data, key, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });

        const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
        res.data = JSON.parse(jsonString); // now we have decrypted JSON
      } catch (e) {
        console.error("Response decryption failed:", e);
      }
    }

    // console.log("data after decryption", res.data);
    return res;
  },
  (error) => {
    console.error("[API ERROR]", error?.config?.url, error);
    return Promise.reject(error);
  }
);

export default encryptedapiRequest;
